

new LiveEvent('click', '[data-simple-pagination-link]', function pagination(e) {
  const link = this;
  e.preventDefault();
  const currentPagination = link.closest('[data-simple-pagination]');
  if (!currentPagination) {
    return;
  }
  const key = currentPagination.dataset.simplePagination;
  if (!key) {
    return;
  }

  link.classList.add('_disabled');
  const jax = new Jax(
    link.getAttribute('href'),
    'GET',
    false
  );

  jax.send().then((html) => {
    const page = document.createElement('div');
    page.innerHTML = html;

    const currentList = document.querySelector(`[data-simple-pagination-list="${key}"]`);
    const newList = page.querySelector(`[data-simple-pagination-list="${key}"]`);

    const newPagination = page.querySelector(`[data-simple-pagination="${key}"]`);

    if (newPagination) {
      currentPagination.innerHTML = newPagination.innerHTML;
    } else {
      currentPagination.remove();
    }

    console.log(currentList)
    Array.from(newList.children).forEach((child) => {
      console.log(child)
      currentList.appendChild(child);
    });
    console.log(currentList)


    document.dispatchEvent(new Event('DOMContentMutated'));
  });



});